import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';          
import { store } from './app/store';    
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';              

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode>                       
    <Provider store={store}>                    
    <App/>
    </Provider>
</React.StrictMode>
);
